import { NavLink, useLocation, matchPath } from "react-router-dom"
import gaiaLogo from "@/assets/gaia-logo.png"
import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useState } from "react"
import { useChat } from "@/modules/Chat/context/ChatContext"
import { useAuth } from "@/modules/Auth/context/AuthContext"

interface NavItem {
  path: string
  label: string
  icon: string
}

export const AppBar = () => {
  const { user } = useAuth()
  const [navItems, setNavItems] = useState<NavItem[]>([
    { path: "/dashboard", label: "Dashboard", icon: "chart-pie-alt" },
    { path: "/events", label: "Eventos", icon: "fi fi-ts-calendar" },
    {
      path: "/my-subscriptions",
      label: "Inscrições",
      icon: "fi fi-ts-bullseye-pointer",
    },
    {
      path: "/reprises",
      label: "Conteúdos",
      icon: "fi fi-ts-clapperboard-play",
    },
  ])

  function checkIsActive(path: string) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation()

    return matchPath({ path, end: false }, pathname)
  }

  const FloatingChatButton = () => {
    // Estado para controlar se o balão está visível
    const [showBubble, setShowBubble] = useState(false)

    useEffect(() => {
      // 1. Verifica se já foi mostrado anteriormente (usando localStorage)
      const hasSeenBubble = localStorage.getItem("gaia_bubble_seen")

      if (!hasSeenBubble) {
        // 2. Espera um pequeno delay antes de mostrar (ex: 1 segundo após carregar)
        const showTimeout = setTimeout(() => {
          setShowBubble(true)
          // Marca no localStorage que já foi visto
          localStorage.setItem("gaia_bubble_seen", "true")
        }, 1000)

        // 3. Define um tempo para o balão desaparecer sozinho (ex: 6 segundos)
        const hideTimeout = setTimeout(() => {
          setShowBubble(false)
        }, 7000) // 1s delay + 6s visível

        // Limpeza dos timeouts se o componente for desmontado
        return () => {
          clearTimeout(showTimeout)
          clearTimeout(hideTimeout)
        }
      }
    }, [])
    const { toggleChat } = useChat()

    return (
      <div className="relative">
        {/* O Botão Principal (com o seu estilo atualizado) */}
        {/* <button
          onClick={toggleChat}
          className="absolute inset-x-0 -top-8 mx-auto flex size-12 items-center justify-center rounded-full border border-zinc-700 bg-zinc-900 shadow-lg ring-4 ring-white/10"
        >
          <img
            src={gaiaLogo}
            alt="GAIA Logo"
            width="25"
          />
        </button> */}

        {/* AnimatePresence permite animações na saída (exit) */}
        <AnimatePresence>
          {showBubble && (
            <motion.div
              // -- Posicionamento Tailwind --
              // Coloca o balão no canto superior direito do botão
              className="absolute -top-16 left-1/2 z-50 ml-7 origin-bottom-left"
              // -- Animação Framer Motion --
              initial={{ opacity: 0, scale: 0.5, y: 10 }} // Estado inicial (escondido)
              animate={{ opacity: 1, scale: 1, y: 0 }} // Estado visível
              exit={{ opacity: 0, scale: 0.8, y: 10 }} // Estado de saída
              transition={{
                type: "spring", // Efeito de mola para ficar mais orgânico
                stiffness: 300,
                damping: 20,
                duration: 0.5,
              }}
            >
              {/* O Balão em si */}
              <div className="relative rounded-xl rounded-bl-none bg-orange-500 px-4 py-2 shadow-2xl">
                <p className="whitespace-nowrap text-sm font-semibold text-white">
                  Olá! Eu sou GAIA
                </p>

                {/* O "triângulo" do balão de chat (opcional, mas fica legal) */}
                <div className="absolute bottom-0 left-[-8px] size-0 border-b-0 border-r-[10px] border-t-[10px] border-r-orange-500 border-t-transparent"></div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    )
  }

  useEffect(() => {
    if (user.pesTipo === 3) {
      const memberNavItems: NavItem[] = [
        { path: "/dashboard", label: "Dashboard", icon: "chart-pie-alt" },
        { path: "/events", label: "Eventos", icon: "fi fi-ts-calendar" },
        {
          label: "Network",
          path: "/network",
          icon: "network-analytic",
        },
        {
          label: "Mentorias",
          path: "/mentoring",
          icon: "handshake",
        },
      ]

      setNavItems(memberNavItems)
    }
  }, [])

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 z-40 mx-5 mb-3 rounded-xl border-t border-[#555555] bg-[rgba(15,15,15,.7)] bg-[url('./assets/grain-texture.png')] bg-cover bg-no-repeat bg-blend-multiply backdrop-blur-sm">
        <div className="relative grid h-16 grid-cols-4">
          {/* {user.pesTipo === 3 && (
            <div className="col-span-4 w-full">
              <FloatingChatButton />
            </div>
          )} */}
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `transition-smooth flex flex-col items-center justify-center gap-1 ${
                  isActive
                    ? "rounded-full text-orange-500"
                    : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              <i
                className={`fi fi-${checkIsActive(item.path) ? "ss-" : "ts-"}${item.icon} text-xl`}
              ></i>
              <span className={`text-xs font-${checkIsActive(item.path) ? "bold" : "medium"}`}>
                {item.label}
              </span>
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  )
}
